<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Családi belépések</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <div class="csaladi-belepes">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Kinek van belépése a családban?</ion-card-title>
        <ion-card-subtitle>
          Ha valakinek nincs, itt létrehozhatod neki – nem kell megvárni az iskolát.
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content style="padding:0 0 8px">
        <div class="allapot" *ngIf="toltodik">
          <ion-spinner name="dots"></ion-spinner> Betöltés…
        </div>
        <div class="allapot hiba" *ngIf="!toltodik && hiba">
          <ion-icon name="alert-circle-outline"></ion-icon> {{ hiba }}
          <ion-button size="small" fill="clear" (click)="betoltes()">Újra</ion-button>
        </div>
        <div class="allapot hiba" *ngIf="!toltodik && !hiba && !keycloak">
          <ion-icon name="alert-circle-outline"></ion-icon> {{ uzenet }}
        </div>

        <!--  A FRISSEN KÉSZÜLT BELÉPÉS. A jelszót nem tároljuk és nem küldjük el
              levélben: ez az egyetlen alkalom, amikor látszik. -->
        <div class="uj-belepes" *ngIf="ujBelepes">
          <h3>Kész: {{ ujBelepes.nev }} belépése</h3>
          <div class="adatsor"><span>Felhasználónév</span><b>{{ ujBelepes.azonosito }}</b></div>
          <div class="adatsor"><span>Ideiglenes jelszó</span><b>{{ ujBelepes.jelszo }}</b></div>
          <div class="figyelmeztetes">
            <span *ngIf="ujBelepes.jelszo_forras === 'szuletes'">
              A jelszó a <b>születési dátuma</b> (ÉÉÉÉHHNN) — ezt fejből tudja.
            </span>
            <span *ngIf="ujBelepes.jelszo_forras !== 'szuletes'">
              Nincs rögzített születési dátuma, ezért véletlen jelszót kapott — <b>ezt át kell adnod neki</b>,
              máshonnan nem tudja megtudni.
            </span>
            <br>A jelszó <b>végleges</b>: azonnal be lehet vele lépni, a rendszer nem kér cserét.
            Ezt a jelszót most látod utoljára — nem tároljuk el.
            <span *ngIf="ujBelepes.atvett_fiok">
              <br>Ehhez az e-mail címhez <b>már tartozott belépés</b>, de gondviselő nem: azt a fiókot vettük át,
              ezért a felhasználóneve a régi maradt.
            </span>
            <span *ngIf="ujBelepes.email_nelkul">
              <br>Az e-mail címét nem tudtuk hozzárendelni (már egy másik belépéshez tartozik),
              ezért a <b>felhasználónevével</b> tud belépni.
            </span>
          </div>
          <div class="gombok">
            <ion-button size="small" color="success" (click)="masol()">
              <ion-icon slot="start" name="copy-outline"></ion-icon>Másolás
            </ion-button>
            <ion-button size="small" fill="outline" color="medium" (click)="bezarUj()">Rendben</ion-button>
          </div>
        </div>

        <ion-list [inset]="true" *ngIf="!toltodik && !hiba && tagok.length">
          <ion-item *ngFor="let t of tagok" lines="full">
            <ion-icon slot="start" [name]="t.fajta === 'tanulo' ? 'school-outline' : 'person-outline'"
                      [color]="t.van ? 'success' : 'medium'"></ion-icon>
            <ion-label>
              <div class="tag-nev">{{ t.nev }}</div>
              <div class="tag-kapcsolat">{{ t.kapcsolat }}</div>
              <div class="tag-azonosito">{{ t.azonosito }}</div>
              <!--  Az e-mail a létrehozás ELŐTT javítható: rossz címmel készült fiókot
                    utólag csak az iskola tudna helyrehozni. A javítás a nyilvántartásba
                    is visszaíródik. -->
              <ion-input *ngIf="!t.van && keycloak" class="email-mezo" type="email"
                         label="E-mail (a belépéshez)" labelPlacement="stacked" fill="outline"
                         placeholder="nincs megadva" [(ngModel)]="t.ujEmail"></ion-input>
              <div class="tag-azonosito" *ngIf="t.van && t.email">{{ t.email }}</div>
            </ion-label>

            <div slot="end">
              <ion-chip *ngIf="t.van && t.engedelyezve !== false" color="success" outline="true">
                <ion-icon name="checkmark-circle-outline"></ion-icon>
                <ion-label>van belépése</ion-label>
              </ion-chip>
              <ion-chip *ngIf="t.van && t.engedelyezve === false" color="warning" outline="true">
                <ion-icon name="lock-closed-outline"></ion-icon>
                <ion-label>letiltva</ion-label>
              </ion-chip>
              <ion-button *ngIf="!t.van && keycloak" size="small" color="primary"
                          [disabled]="letrehozasFolyamatban === t.azonosito"
                          (click)="letrehoz(t)">
                <ion-icon slot="start" name="key-outline"></ion-icon>
                Belépés létrehozása
              </ion-button>
            </div>
          </ion-item>
        </ion-list>

        <div class="allapot" *ngIf="!toltodik && !hiba && !tagok.length">
          <ion-icon name="people-outline"></ion-icon>
          Nincs olyan családtag, akinek innen belépést lehetne készíteni.
        </div>

        <!--  HIÁNYZÓ GONDVISELŐ. Ha a másik szülő a nyilvántartásból is hiányzik,
              itt vehető fel: törzsadat + gyerekhez kötés + belépés egy lépésben. -->
        <div style="padding:4px 16px 8px" *ngIf="!toltodik && !hiba && keycloak && gyerekek.length">
          <ion-button size="small" fill="outline" color="primary" (click)="ujForm = !ujForm">
            <ion-icon slot="start" name="person-add-outline"></ion-icon>
            Hiányzó gondviselő felvétele
          </ion-button>
        </div>

        <div class="uj-gondviselo" *ngIf="ujForm">
          <ion-input label="Vezetéknév" labelPlacement="stacked" fill="outline"
                     [(ngModel)]="ujGondviselo.vez"></ion-input>
          <ion-input label="Keresztnév" labelPlacement="stacked" fill="outline"
                     [(ngModel)]="ujGondviselo.ker"></ion-input>
          <ion-input label="E-mail" labelPlacement="stacked" fill="outline" type="email"
                     [(ngModel)]="ujGondviselo.email"></ion-input>
          <ion-input label="Születési dátum (ebből lesz a jelszó)" labelPlacement="stacked"
                     fill="outline" type="date" [(ngModel)]="ujGondviselo.szul_ido"></ion-input>
          <ion-select label="Melyik gyermekhez" labelPlacement="stacked" fill="outline"
                      interface="popover" [(ngModel)]="ujGondviselo.tanulo">
            <ion-select-option *ngFor="let gy of gyerekek" [value]="gy.azonosito">{{ gy.nev }}</ion-select-option>
          </ion-select>
          <ion-select label="Kapcsolat" labelPlacement="stacked" fill="outline"
                      interface="popover" [(ngModel)]="ujGondviselo.rokonsag">
            <ion-select-option *ngFor="let r of rokonsagok" [value]="r.id">{{ r.nev }}</ion-select-option>
          </ion-select>
          <ion-note color="medium" style="font-size:.82rem">
            A gondviselő bekerül a nyilvántartásba, hozzákötjük a gyermekhez, és belépést is kap.
            Ha nem adsz meg születési dátumot, véletlen jelszót kap — azt át kell adnod neki.
          </ion-note>
          <div class="gombok">
            <ion-button size="small" color="success" [disabled]="letrehozasFolyamatban === 'uj'"
                        (click)="ujGondviseloMentes()">
              <ion-icon slot="start" name="save-outline"></ion-icon>Felvétel és belépés
            </ion-button>
            <ion-button size="small" fill="clear" color="medium" (click)="ujForm = false">Mégse</ion-button>
          </div>
        </div>

        <ion-note color="medium" style="display:block;padding:0 16px 8px;font-size:.82rem"
                  *ngIf="!toltodik && tagok.length">
          Csak a saját családod jelenik meg: a gondviselő a gyermekeit és a gyermekei másik gondviselőjét
          látja, a tanuló a gondviselőit. A kört a kiszolgáló állítja össze a nyilvántartásból.
          Akinek már van működő belépése, annak a jelszavát innen nem lehet felülírni — ott a
          jelszó-visszaállítás a helyes út.
        </ion-note>
        <!-- Az új családtag belépésével az ő adatai is a rendszerbe kerülnek: az adatkezelési szabályzat
             innen is elérhető legyen (Nkt. 43. § (1); nyilvános oldal, /adatkezeles). -->
        <ion-note color="medium" style="display:block;padding:0 16px 8px;font-size:.82rem">
          Hogyan kezeli az iskola a személyes adatokat? <a routerLink="/adatkezeles">Adatkezelési szabályzat</a>
        </ion-note>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
